import { render, staticRenderFns } from "./RouterTab.vue?vue&type=template&id=db427a38&scoped=true&"
import script from "./RouterTab.vue?vue&type=script&lang=ts&"
export * from "./RouterTab.vue?vue&type=script&lang=ts&"
import style0 from "./RouterTab.vue?vue&type=style&index=0&id=db427a38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db427a38",
  null
  
)

export default component.exports